import { configureStore } from '@reduxjs/toolkit'
import ProjectsSlice from "./ProjectsSlice";
import CustomerClientsSlice from "./CustomerClientsSlice";
import HistoriesSlice from "./HistoriesSlice";
import ProductsSlice from "./ProductsSlice";
import CustomersSlice from "./CustomersSlice";

export default configureStore({
  reducer: {
    products: ProductsSlice,
    projects: ProjectsSlice,
    customerClients: CustomerClientsSlice,
    histories: HistoriesSlice,
    customers: CustomersSlice
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: {
      // Ignore these action types
      ignoredActions: ['projects/updateQuoteStatus/fulfilled', 'projects/getQuoteById/fulfilled']
    }})
})